"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const actions = __importStar(require("../actions"));
const reducer_1 = require("../reducer");
const _1 = require(".");
function StoreLookup({ searchForPractices, practicesList, setPractice, practiceSearchError, practice, }) {
    const { id } = (0, react_router_dom_1.useParams)();
    const history = (0, react_router_dom_1.useHistory)();
    const queryParams = (0, utils_1.parseQuery)(location.search);
    const storeLinkCampaign = (0, react_1.useRef)(queryParams[config_1.QUERY_KEY.STORE_LINK_CAMPAIGN]);
    const otlRef = (0, react_1.useRef)(queryParams[config_1.QUERY_KEY.OTL]);
    const [, setCookie] = (0, react_cookie_1.useCookies)(['storeLinkCampaign']);
    (0, react_1.useEffect)(() => {
        if (id) {
            searchForPractices(id);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (practicesList && practicesList.locationId) {
            setPractice(practicesList);
        }
    }, [practicesList]);
    (0, react_1.useEffect)(() => {
        if (practice && storeLinkCampaign.current && otlRef.current) {
            setCookie('storeLinkCampaign', {
                campaignId: storeLinkCampaign.current,
                storeId: practice?.adsStoreNumber,
                otl: otlRef.current,
            }, { path: '/' });
        }
    }, [practice, storeLinkCampaign.current, otlRef.current, setCookie]);
    (0, react_1.useEffect)(() => {
        if (practiceSearchError) {
            (0, utils_1.toastError)('Practice Not Found!');
            history.push('/');
        }
    }, [practiceSearchError]);
    if (practice) {
        return (0, jsx_runtime_1.jsx)(_1.Wizard, {});
    }
    else {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    }
}
function mapStateToProps(state) {
    return {
        practicesList: reducer_1.selectors.practicesList(state),
        practiceSearchError: reducer_1.selectors.practiceSearchError(state),
        practice: reducer_1.selectors.practice(state),
    };
}
const mapDispatchToProps = {
    searchForPractices: apiActions.searchForPractices,
    setPractice: actions.setPractice,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(StoreLookup);
